import { useCreativeTagDetails } from './useCreativeTagDetails'

/** Games carrying a tag: the `games` list of the tag detail. */
export const useTagGamesListing = (tagId: string | null) => {
  const { data, ...rest } = useCreativeTagDetails(tagId)
  return { data: data ? { tag: data.tag, games: data.games } : undefined, ...rest }
}
